import styled from 'styled-components';

export default styled.div`
	position: relative;
	width: var(--px-1050);
	align-self: center;

	.legend {
		position: absolute;
		bottom: var(--px-50);
		left: var(--px-50);
	}

	path.highcharts-point {
		stroke: var(--neutrals-300);
		&.highcharts-null-point {
			fill: var(--neutrals-25);
		}
	}
`;
